export default __webpack_public_path__ + "static/media/Dapazin-10-ban.e385099f.jpg";